import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
// import { createBrowserHistory } from 'history';
import { configureStore } from '../store';
import { setAuthorizationToken, setCurrentUser } from '../store/actions/auth';
import { jwtDecode } from 'jwt-decode';
import Main from './Main';

const store = configureStore();
// var hist = createBrowserHistory();

if (localStorage.jwtToken) {
	setAuthorizationToken(localStorage.jwtToken);
	try {
		store.dispatch(setCurrentUser(jwtDecode(localStorage.jwtToken)));
	} catch (e) {
		store.dispatch(setCurrentUser({}));
	}
}
const App = () => (
	<>
		<Provider store={store}>
			<Router>
				<Main />
			</Router>
		</Provider>
	</>
);
export default App;
